<script>
    import API from '../../../../api';
    import { RESERVATION_TECHRESERVATION_DELETE_DISCOUNT_ENDPOINT } from '../../../../endpoints';
    import TechInfoTable from './tech-info-table.vue';
    import ActionsHeaderRendererAddItem from './actions-header-renderer-add-item.vue';
    import ActionsCellRendererRemoveItem from './actions-cell-renderer-delete-item.vue';

    export default {
        extends: TechInfoTable,
        components: {
            actionsHeaderRendererAddItem: ActionsHeaderRendererAddItem,
            actionsCellRendererRemoveItem: ActionsCellRendererRemoveItem,
        },
        data() {
            return {
                addModalId: `add-discounts-modal-${this.reservationId}`,
                modalTitle: 'Add Discount',
                modalLabel: 'Discount',
                module: 'discount',
                columnDefs: [
                    {
                        headerName: '',
                        maxWidth: 60,
                        flex: 1,
                        sortable: false,
                        resizable: false,
                        cellClass: 'tech-info-remove-item',
                        headerComponent: 'actionsHeaderRendererAddItem',
                        headerComponentParams: {
                            addItem: () => {
                                this.showAddItem();
                            },
                            conditional: true,
                        },
                        cellRenderer: 'actionsCellRendererRemoveItem',
                        cellRendererParams: {
                            deleteItem: id => {
                                this.deleteItem(id, RESERVATION_TECHRESERVATION_DELETE_DISCOUNT_ENDPOINT);
                            },
                        },
                    },
                    {
                        headerName: 'Discounts',
                        sortable: false,
                        field: 'title',
                        flex: 1,
                        resizable: false,
                        autoWidthExclude: true,
                        minWidth: 200,
                    },
                    {
                        headerName: 'Coupon',
                        sortable: false,
                        field: 'total_net',
                        flex: 1,
                        resizable: false,
                    },
                    {
                        headerName: 'Amount',
                        sortable: false,
                        field: 'value',
                        flex: 1,
                        resizable: false,
                        cellClass: 'ag-right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                    },
                ],
            };
        },
        methods: {},
    };
</script>
